/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPrinterIcon16Light } from './TechPrinterIcon16Light';
import { TechPrinterIcon16Regular } from './TechPrinterIcon16Regular';
import { TechPrinterIcon16Solid } from './TechPrinterIcon16Solid';
import { TechPrinterIcon20Light } from './TechPrinterIcon20Light';
import { TechPrinterIcon20Regular } from './TechPrinterIcon20Regular';
import { TechPrinterIcon20Solid } from './TechPrinterIcon20Solid';
import { TechPrinterIcon24Regular } from './TechPrinterIcon24Regular';
import { TechPrinterIcon24Solid } from './TechPrinterIcon24Solid';
import { TechPrinterIcon32Regular } from './TechPrinterIcon32Regular';
import { TechPrinterIcon64Regular } from './TechPrinterIcon64Regular';
var sizes = {
    16: {
        light: TechPrinterIcon16Light,
        regular: TechPrinterIcon16Regular,
        solid: TechPrinterIcon16Solid,
    },
    20: {
        light: TechPrinterIcon20Light,
        regular: TechPrinterIcon20Regular,
        solid: TechPrinterIcon20Solid,
    },
    24: {
        regular: TechPrinterIcon24Regular,
        solid: TechPrinterIcon24Solid,
    },
    32: {
        regular: TechPrinterIcon32Regular,
    },
    64: {
        regular: TechPrinterIcon64Regular,
    },
};
export var TechPrinterIcon = forwardRef('TechPrinterIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
